import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Button from "sushiweb/Button";
import ListPagination from "../../components/Common/ListPagination";
import {
  getChatDepartments,
  resetState,
} from "../../store/actions/ChatDepartments";
import FilterButton from "../../components/Common/FilterButton";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ChatDepartmentsModal from "../../components/ChatDepartments/ChatDepartmentsModal";
import ChatDepartmentsList from "../../components/ChatDepartments/ChatDepartmentsList";
import { useHistory, useParams } from "react-router-dom";
import { getPath } from "../../utils";

const ChatDepartments = ({
  activeFilters,
  getChatDepartments,
  chatDepartments,
  nextPage,
  prevPage,
  resetState,
}) => {
  const [modalState, setModalState] = useState(false);
  const params = useParams();
  const history = useHistory();
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.LOGISTICS_CHAT_DEPARTMENTS];
  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
    setActiveId("");
    resetState({ state: "activeChatDepartment" });
    if (
      history.location.pathname !== "/chat-departments" &&
      getPath(chatDepartments, "length", -1) > 0
    ) {
      //no page refresh, hence redux store will persist
      window.history.pushState("", "", "/chat-departments");
    } else if (
      history.location.pathname !== "/chat-departments" &&
      getPath(chatDepartments, "length", -1) === 0
    ) {
      // clear everything and page refresh
      history.push("/chat-departments");
    }
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      getChatDepartments(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      getChatDepartments(activeFilters, pageRequest);
    }
  };

  useEffect(() => {
    if (shouldRenderList === true) {
      getChatDepartments();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(activeFilters)]);

  return (
    <ChatDepartmentsViewContainer className="chat-departments-View container">
      <FlexContainer align="flex-start">
        <Heading>Chat Departments</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.READ]}>
            <FilterButton
              activeFilters={activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.UPDATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="chatDepartmentsAddNewBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <ChatDepartmentsList list={chatDepartments} handleClick={handleClick} />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <ChatDepartmentsModal
          activeId={activeId}
          modalState={modalState}
          handleClose={handleClose}
        />
      )}
    </ChatDepartmentsViewContainer>
  );
};

const ChatDepartmentsViewContainer = styled.section``;

function mapStateToProps(state) {
  const { ChatDepartments } = state;
  return {
    chatDepartments: ChatDepartments.chatDepartments,
    nextPage: ChatDepartments.nextPage,
    prevPage: ChatDepartments.prevPage,
    activeFilters: ChatDepartments.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getChatDepartments: bindActionCreators(getChatDepartments, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatDepartments);
